export enum OsasComplaintBurden {
    decreased = 'Afgenomen',
    increased = 'Toegenomen',
    stayedSame = 'Gelijk gebleven',
}
